import { useState } from 'react';
import { useContext } from 'react';
import Button from '../ui/Button';
import './BillingGridAddRow.scss';
import WrapperModal from '../ui/WrapperModal';
import BillingGridAddRowForm from './BillingGridAddRowForm';
import AuthContext from '../../store/auth-context';

const BillingGridAddRow = ({
	tableNumber,
	studyId,
	studyStatus
}) => {
	const [startAddRow, setStartAddRow] = useState(false);
	const authCtx = useContext(AuthContext);

	const newRowHandler = () => {
		setStartAddRow(true);
	};
	const cancelAddRow = () => {
		setStartAddRow(false);
	};

	const endAddRowHandler = () => {
		setStartAddRow(false);
	};
	return (
		<>
			{authCtx.userData.role === 'QA' &&
				studyStatus !== 'STUDY_COMPLETED' && (
					<div className='add-row-button-container'>
						<Button
							className='add-row-button'
							onClick={newRowHandler}
						>
							+ New row
						</Button>
						{startAddRow && (
							<WrapperModal onDismiss={cancelAddRow}>
								<BillingGridAddRowForm
									onCancel={cancelAddRow}
									tableNumber={tableNumber}
									studyId={studyId}
									onEndProcess={endAddRowHandler}
								/>
							</WrapperModal>
						)}
					</div>
				)}
		</>
	);
};
export default BillingGridAddRow;
